var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { apiGetOneRfpCurrentOffer } from '@/actions/rfpProOfferActions';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useRfpOneProfessional } from '@/hooks/pages/rfp/professional/useRfpOneProfessional';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { RfpProOfferSkeleton } from '@/pages/rfp/professional/offer/RfpProOfferSkeleton';
import { RfpProOfferOfferedPage } from '@/pages/rfp/professional/RfpProOfferOffered/RfpProOfferOfferedPage';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED } from '@/utils/constants/rfp/professional/dataType';
import { pagePath } from '@/utils/router/pagePath';
const professionalPath = pagePath.project.professional;
/**
 * コンサルタント：案件提案提出後確認ページのロジック部分
 */
export const RfpProOfferOffered = () => {
    /**
     * 案件提案提出データ 取得
     */
    const fetchOffer = useCallback((dispatch, { has_offer: hasOffer, id }) => __awaiter(void 0, void 0, void 0, function* () {
        // 未提出の場合は処理をスキップ
        if (!hasOffer) {
            return;
        }
        const action = apiGetOneRfpCurrentOffer({ path: { id } }, {});
        yield wrapDispatch(dispatch, action);
    }), []);
    // 案件詳細データ取得, ページ状態管理
    const { id, loading, rfp } = useRfpOneProfessional({
        afterCallbackInApproved: fetchOffer,
    });
    /** 提案提出データ */
    const offer = useTypeSelector((state) => state.professionalRfpOffer.currentOne[id]);
    // ローディング表示
    if ((loading && !rfp) || (loading && !offer)) {
        return _jsx(RfpProOfferSkeleton, {});
    }
    // リダイレクト：案件が存在しない場合
    if (!loading && !rfp) {
        return _jsx(CustomRedirect, { to: professionalPath.list() });
    }
    // リダイレクト: 案件詳細 未承認
    if (rfp.data_type === RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED.value) {
        return _jsx(CustomRedirect, { to: professionalPath.detail(id) });
    }
    // リダイレクト：案件提案提出データが存在しない場合
    if (!rfp.has_offer || (!loading && !offer)) {
        return _jsx(CustomRedirect, { to: professionalPath.detail(id) });
    }
    return _jsx(RfpProOfferOfferedPage, { offer: offer, rfp: rfp });
};
